<template>
	<div class="lazadaprocessed">
		<div style="font-size: 20px;" ><el-button v-show="userPos == 'STORE' || vipLevel === 5 " style="margin-left: 20px;" type="primary" @click="gotopackage()">{{$t("other.a865")}}</el-button></div>
		<div style="margin: 20px 0;display: flex;"  v-for="item in buttonList">
				<div >{{item.desc}}</div>
				<span class="filterbox" >
					<span class="storeBox"  :class="{'ttpactive': item.isActive === index }"   v-for="(ttp,index) in item.value" @click="handleBtn(item,ttp.Id,index)">{{ttp.Name}}</span>
				</span>
		</div>


		<div class="block">
		    <span class="demonstration">{{$t("other.a866")}}：</span>
		    <el-date-picker
		      v-model="value9"
		      type="daterange"
			  @change="getValue"
			  value-format="yyyy-MM-dd"
		      :start-placeholder="$t('other.a45')"
		      :end-placeholder="$t('other.a46')"
		      >
		    </el-date-picker>
		  </div>		


		<div style="display: flex;align-items: center;margin-bottom: 20px;">
			{{$t("other.a867")}}：
			<el-input
			  style="width: 250px;"
			  :placeholder="$t('other.a868')"
			  clearable
			  v-model="ordersnText">
			</el-input>
			<el-button style="margin:0 5px" type="primary" @click="getOrderSn">{{$t('other.a245')}}</el-button>	
		</div>
			<div class="nodata" v-if="!amountList.length" >--{{$t('pendingorder.nodata')}}--</div>
			<div  v-else>
				 <el-table
				      :data="amountList"
					  border
				      style="width: 100%;margin-bottom: 50px;">
				      <el-table-column
				        prop="packagedTime"
				        :label="$t('other.a869')"
				        >
				      </el-table-column>
				      <el-table-column
				        prop="amount"
				        :label="$t('other.a870')">
				      </el-table-column>
					  <el-table-column
					    prop="cancelAmount"
					    :label="$t('other.a871')">
					  </el-table-column>
					  <el-table-column
					    prop="shippedAmount"
					    :label="$t('other.a872')">
					  </el-table-column>
					  <el-table-column
					    prop="escrowAmount"
					    :label="$t('other.a77')">
						<template slot-scope="scope">
							<span>{{scope.row.escrowAmount}}</span>
						</template>
					  </el-table-column>
					  <el-table-column
					    prop="escrowAmount"
					    :label="userPos == 'SELLER' ? $t('other.a873') : $t('other.a874')">
						<template slot-scope="scope">
							<span>{{scope.row.feeAmount}}</span>
						</template>
					  </el-table-column>
					 <el-table-column
					   :label="$t('other.a33')"
					   width="400"
					   >
					   <template slot-scope="scope">
					   	 <el-button size="mini" type="primary" @click="viesDetail(scope.row)">{{$t('other.a875')}}</el-button>
						 <el-button size="mini"  @click="exportXLMS(scope.row)">{{$t('other.a876')}}</el-button>
						  <el-button size="mini"  @click="pintTrakingOrder(scope.row)">{{$t('other.a877')}}</el-button>
					   </template>
					 </el-table-column>
				    </el-table>

				
			</div>
			
				<!-- 分页器 -->
				<div class="Pager">
					<el-pagination
					style="background-color: #fff;"
					  @size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage1"
					:page-sizes="[15, 20, 30, 50]"
					:page-size="offset"
					layout=" total,sizes, prev, pager, next, jumper"
					:total="amountListCount">
					</el-pagination>
				  </div>
			 </div> 
		</div>
	</div>
</template>

<script>
		import {mapState, mapActions , mapMutations} from 'vuex'
		import utils from '../../../utils/utils.js'
		import api from '../../../api/moudles/lazadaorders.js'

	export default{
		data(){
			return {
				req_params:{
					shopIds:null,
					storeIds:null,
					orderId:'',
					offset:15,
					logistics:null,
					page:0,
					start:null,
					end:null,
					platform:'LAZADA',
					shopIds:JSON.parse(localStorage.getItem('userInfo')).lazadaShops.map(p => {return p.sellerId}),
					storeIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId
				},
				req_params_copy:{
					shopIds:null,
					storeIds:null,
					offset:15,
					logistics:null,
					page:0,
					start:null,
					end:null,
				},
				buttonList:[],
				options5: [],
				value10: '',
				storeList: [],
				storeValue:'',
				shopIdlist:[],
				warehouse:[],
				currentPage1:1,
				offset:15,
				page:0,
				storeBtn:[],
				processedListCopy:[],
				isactive:[],
				stockList:[],
				isCloundStore:1,
				isActive:true,
				scanNum:'',
				shoplist:[],
				storelist:[],
				storeListCopy:JSON.parse(localStorage.getItem('warehouse')),
				dialogVisible:false,
				imgUrlList:[],
				shopInfo:[],
				ordersnText:'',
				allShopId:[],
				allStoreId:[],
				value9: [],
				activeList:[0,0,0]				
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				processedList: state=>state.processed.processedList || '',//云仓的订单
				cloudeList: state=>state.processed.cloudeList || '',//测品仓的订单
				country:state=>state.login.userInfo.country || '',
				vipLevel:state=>state.login.userInfo.vipLevel || '',
				userPos: state=>state.login.userInfo.userPos,
				count: state=>state.processed.count,
				logisticsInfo: state=>state.lazadaorders.logisticsInfo ,
				amountList: state=>state.lazadaorders.amountList ,
				amountListCount: state=>state.lazadaorders.amountListCount ,
				tableList: state=>state.lazadaorders.tableList ,
				falg:state=>state.lazadaorders.falg ,
				allLogistic:state=>state.processed.allLogistic ,
			}),
			
			orderList(){
				if(this.isCloundStore === 1) {
					return this.processedList
				}else{
					return this.cloudeList
				}
			},
		},
		watch:{
			logisticsInfo(){
				console.log(this.req_params_copy)
				if(this.userPos === 'SELLER'){
					this.req_params_copy.shopIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.req_params_copy.storeIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.buttonList=[{
						id:0,
						desc:this.$t('other.a359')+'：',
						isActive:this.activeList[0],
						value:this.req_params_copy.shopIds,
					},
					{
						id:2,
						desc:this.$t('other.a878'),
						isActive:this.activeList[1],
						value:this.logisticsInfo,
					}]
					console.log(this.req_params)
					this.getProcessedOrdersLazada(this.req_params)
				}else{
					
					this.req_params_copy.storeIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.buttonList=[{
						id:0,
						desc:this.$t('other.a653')+'：',
						isActive:this.activeList[0],
						value:this.req_params_copy.storeIds,
					},
					{
						id:2,
						desc:this.$t('other.a878'),
						isActive:this.activeList[1],
						value:this.logisticsInfo,
					},{
						id:3,
						desc:this.$t('other.a879')+'：',
						isActive:this.activeList[2],
						value:JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {return {
							Id:p.userId,
							Name:p.userName,
						}})
					}]

					this.buttonList[2].value[0]={
						    Id:'all',
							Name:this.$t('other.a358'),
							isActive:this.isActive[2]
					}
					console.log('store',this.req_params)
					
					this.getProcessedOrdersLazada(this.req_params)
				}
					
			},


			falg(){
				if(this.falg){
					let obj={
						list:this.tableList,
						shopInfo:this.shopInfo
					}
					localStorage.setItem('tableList',JSON.stringify(obj))
					
					let router = this.$router.resolve(
					  { 
					    name: "processedDetail" ,
					  }
					);
					window.open(router.href, '_blank');
				}
			},
			ordersnText(){
				if(this.ordersnText == ''){
					this.req_params.orderId=''
					this.getProcessedOrdersLazada(this.req_params)
				}
			}
		},
		created(){
			this.init()
		},
		methods:{
			...mapActions('lazadaorders',[
				'getProcessedOrderSn',
				'getProcessedOrderInfo',
				'getIDacountProcessedList',
				'getPackagedOrderByStore',//仓库帐号下猎取已出库出库的订单
				'setPackaged',
				'getProcessedOrdersLazada',
				'getProcessedOrdersByStorelazada',
				'getLogisticsBystorelazada',
				'getLogisticsBysellerLazada',
				'getProcessedOrderBySellerLazada',
				'getProcessedOrderByStorelazada',
				'getOrderByOrderId',
			
			]),
			
			...mapActions('print',[
			   'getParams',
			   'getAllOrders',
			   'getStoreOrders',
						   
			]),
		
			
			...mapMutations('processed',[
				'SET_PROCESSED_ORDER_LIST',
			]),

			demo(){
				console.log(this.logisticsInfo)
			},

			pintTrakingOrder(params){
				let ccp=this.req_params
				
				ccp.packageTime=params.packagedTime
				api
				.getProcessedOrderBySellerLazada(ccp)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家获取所有已处理的订单',res.data)
						localStorage.setItem('signorder', JSON.stringify(res.data))
						const {href}=this.$router.resolve({
							name:'signOrder',
						
						}) 
						window.open(href)
					}
				})
			},
			

			getValue(){
				console.log(this.value9)
				this.req_params.start=this.value9[0]
				this.req_params.end=this.value9[1]
				this.req_params.packageTime=null
				console.log(this.req_params)
				if(this.userPos === 'SELLER'){
					this.getLogisticsBysellerLazada(this.req_params)
				}

				if(this.userPos == 'STORE') {

					this.getLogisticsBystorelazada(this.req_params)
				}
				
				
			},	
			
			exportXLMS(params){
				console.log(this.req_params)
				console.log(params)
				this.req_params.packageTime=params.packagedTime
				
				
				api
				.getProcessedOrderBySellerLazada(this.req_params)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家获取所有已处理的订单',res.data)
						
						let list=['Date','OrderID','Sku_Qty','Integral','Shop']
						let arr=[]
						console.log(res.data)
						res.data.forEach(p => {
							
								arr.push({
									'Date':params.packagedTime,
									'OrderID':p.orderId,
									'Sku_Qty':p.orderItems.length,
									'Integral':p.fee,
									'Shop':p.userId
								})
							
						})
						console.log(arr)
						utils.exPortEXml(arr,list,'processedOrder')
					}
				})
			},			
			
			
			
			showShopName(id){
				let ccp=null
				if(this.userPos === 'SELLER'){
					ccp=utils.lazadashowshopNameByshopId()
					return ccp[id]
				}else if(this.userPos === 'STORE'){
					ccp=utils.lazadashowstoreNameBystoreId()
					return ccp[id]
				}
				
				
			},
			
			
			getOrderSn(){
				this.req_params.orderId=this.ordersnText
				this.getProcessedOrdersLazada(this.req_params)
			},
			
			
			gotopackage(){
				let shopeePlatform=false
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve(
				  { 
				    name: "package" ,
				  }
				);
				
				window.open(router.href, '_blank');
			},


			viesDetail(params){
				console.log(this.req_params)
				this.shopInfo=params
				let ccp=this.req_params
				if(this.userPos === 'SELLER'){
					ccp.shopIds= this.req_params.shopIds
					ccp.packageTime=params.packagedTime
					this.getProcessedOrderBySellerLazada(ccp)
				}else if(this.userPos === 'STORE') {
					ccp.shopIds=this.req_params.shopIds
					ccp.packageTime=params.packagedTime
					this.getProcessedOrderBySellerLazada(ccp)
				}
			},
			
			
			
			//扫描枪调用的方法
			packBageOut(){
				if(this.scanNum){
					this.setPackaged({orderId:this.scanNum})
				}else{
					
					return
				}
			},
			
			
			
			handleBtn(item,value,index){
				
				console.log(item.id)
				console.log(value)
				console.log(index)
				this.buttonList.forEach(p => {
					p.value.forEach((k,index) => {
						if(value === k.Id && p.id === item.id){
							p.isActive=index
						}
					})
				})
				if(this.userPos == 'SELLER'){
					if(item.id == 0){
						value === '' ? this.req_params.shopIds=this.allShopId : this.req_params.shopIds=[value]
					}else if(item.id == 2){
						value === '' ? this.req_params.logistics=this.allLogistic : this.req_params.logistics=value
						
					}
					this.req_params.packageTime=''
					console.log(this.req_params)
					this.getProcessedOrdersLazada(this.req_params)
				}else if(this.userPos === 'STORE'){
					if(item.id == 0){
						value === '' ? this.req_params.storeIds=this.allStoreId : this.req_params.storeIds=[value]
					}else if(item.id == 1) {
						value === '' ? this.req_params.logistics=this.allLogistic : this.req_params.logistics=value
					}
					
					console.log(this.req_params)
					this.getProcessedOrdersLazada(this.req_params)
				}
			},
		
			init(){ 
				this.value9[0]=utils.getRecentSevenDay(-7)
				this.value9[1]=utils.getRecentSevenDay(1)
				this.req_params.start=this.value9[0]
				this.req_params.end=this.value9[1]

				if(this.userPos === 'STORE'){
				this.req_params.storeIds=JSON.parse(localStorage.getItem('userInfo')).storeIds
				this.req_params_copy.storeIds=utils.getAllwarehouse().map(p => {return {Name:p.label,Id:p.value}})
				this.allStoreId=utils.getAllwarehouse().map(p => {return p.value}).slice(1)
				this.getLogisticsBystorelazada({storeIds:this.allStoreId})
				console.log(this.req_params)
				setTimeout(() => {
					this.req_params_copy.storeIds[0]={
						Id:'',
						Name:this.$t('other.a358')
					}
					this.buttonList=[{
						id:0,
						desc:this.$t('other.a653')+'：',
						isActive:0,
						value:this.req_params_copy.storeIds,
					},
					{
						id:1,
						desc:this.$t('other.a878'),
						isActive:0,
						value:this.logisticsInfo,
					}]
					this.req_params.storeIds=this.allStoreId
					
				},500)
					
				}else if(this.userPos === 'SELLER'){
					this.req_params.shopIds=utils.getAllshopLazada().map(p => {return {Name:p.label,Id:p.value}})
					
					this.req_params_copy.shopIds=utils.getAllshopLazada().map(p => {return {Name:p.label,Id:p.value}})
					this.req_params_copy.storeIds=utils.getAllwarehouseLazada().map(p => {return {Name:p.label,Id:p.value}})
					this.allShopId=utils.getAllshopLazada().map(p => {return p.value}).slice(1)
					this.getLogisticsBysellerLazada({shopIds:this.allShopId})
					setTimeout(() => {
						this.req_params_copy.shopIds[0]={
							Id:'',
							Name:this.$t('other.a358')
						}
						this.req_params_copy.storeIds[0]={
							Id:'',
							Name:this.$t('other.a358')
						}
						this.buttonList=[{
							id:0,
							desc:this.$t('other.a359')+'：',
							isActive:0,
							value:this.req_params_copy.shopIds,
						},
						{
							id:2,
							desc:this.$t('other.a878'),
							isActive:0,
							value:this.logisticsInfo,
						}]
						this.req_params.shopIds=this.allShopId
						this.getProcessedOrdersLazada(this.req_params)
						
					},500)
				}
				
				
				
				
				
				
				// this.getOrdersnInfo()
				
				
			},
			handleSizeChange(val) {
				this.offset=Number(`${val}`)
				console.log(this.offset);
				this.req_params.offset=this.offset
				this.getProcessedOrdersLazada(this.req_params)
			 },
			handleCurrentChange(val) {
				this.page=this.offset*(Number(`${val}`) -1)
				console.log(this.page)
				this.req_params.page=this.page
				this.getProcessedOrdersLazada(this.req_params)
			},
			
		}
	}
</script>

<style>
	.lazadaprocessed{
		flex: 1;
		
	}
	.lazadaprocessed .order-list-item {
			position: relative;
			padding-bottom: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}

		.lazadaprocessed .order-query {
			display: flex;
			justify-content: start;
		
			padding: 10px 10px 10px 0;
			border-bottom: 1px #E0E0E0 solid;
		}

		img {
			width: 100%;
		}

		.lazadaprocessed .nodata{
			margin-top: 100px;
			text-align: center;
			color: #000;
		}
		

		.lazadaprocessed .Pager{
			float: right;
			
		}

		.lazadaprocessed  .el-dropdown-link{
			color: #606266;
		}
	/* 新起点 */
	
  .list-desc{
	  padding: 10px 15px;
  }
	
	.lazadaprocessed .chekbox{
		width: 30px;
		height: 30px;
		line-height: 30px;
	}
	
	.lazadaprocessed .pic-box{
			display: flex;
		    margin: 2px;
			width: 80px;
			height: 80px;
	}
	.lazadaprocessed .return-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 1px;
	}
	
	.lazadaprocessed .storeBox{
		border: 1px solid #eee;
		box-sizing: border-box;
		padding: 5px;
		font-size: 14px;
		cursor: pointer;
		margin:0 2px;
		
	}

	.lazadaprocessed .block{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.lazadaprocessed .storeBox:hover{
		color: #1890ff;
	}
	.lazadaprocessed .return-item-list{
		display: flex;
		align-items: center;
	
	}
	
	.lazadaprocessed .unfold:nth-of-type(n+4){
		display: none;
		
	}
	
	.lazadaprocessed .pic-box-desc{
		width: 350px;
		margin-left: 20px;
	}
	.lazadaprocessed .retrun-reasonr{
		margin-left: 30px;
	}
	.lazadaprocessed .retrun-reasonr-btn{
		display: flex;
		flex-direction: column;
		align-items: center ;
		margin-right: 20px;
	}
	.lazadaprocessed .seller{
		margin-right: 10px;
		font-size: 18px;
	}
	.lazadaprocessed .return-reasonr-desc{
		box-sizing: border-box;
		padding: 3px 0;
	}
	
	
	
	.lazadaprocessed  .ttpactive{
		background-color: #1890ff;
		color: #fff;
	}
	.lazadaprocessed  .ttpactive:hover{
		background-color: #40a9ff;
		color: #fff;
	}
	
	.IdScaneArea .el-input__inner{
		width: 99%;
		height: 130px;
		font-size: 30px;
		margin-top:20px
		
	}
	
	.pic-box{
		width: 80px;
		height: 80px;
	}

	
.filterbox {
    display: flex;
    flex-wrap: wrap;
	flex: 1;
}

.lazadaprocessed .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	
	
	
</style>
